import { Breakpoint, TableCell, TableRow, Theme, useMediaQuery, useTheme } from "@mui/material";
import { PropsWithChildren, ReactNode, useState } from "react";
import ExpandMore from "../../styles/ExpandMore";

export type ExpandableTableRowProps = {
	columnCount: number;
	expandedContent: ReactNode;
	maxCollapseWidth?: Breakpoint;
	canExpand?: boolean;
};

function ExpandableTableRow({
	children,
	expandedContent,
	columnCount,
	maxCollapseWidth,
	canExpand = true,
}: PropsWithChildren<ExpandableTableRowProps>) {
	const theme = useTheme();
	const collapseByBreakpoint = useMediaQuery(theme.breakpoints.down(maxCollapseWidth ?? "xl"));
	const shouldCollapse = maxCollapseWidth ? collapseByBreakpoint : true;
	const [expanded, setExpanded] = useState<boolean>(false);

	if (!canExpand) {
		return <TableRow>{children}</TableRow>;
	}

	if (!shouldCollapse) {
		return (
			<TableRow>
				{children}
				<TableCell>{expandedContent}</TableCell>
			</TableRow>
		);
	}

	return (
		<>
			<TableRow
				sx={
					expanded
						? {
								"& td": {
									borderBottom: "none",
									paddingBottom: 0,
								},
						  }
						: undefined
				}
			>
				{children}
				<TableCell>
					<ExpandMore
						expand={expanded}
						onClick={() => setExpanded(!expanded)}
						aria-expanded={expanded}
						aria-label="show more"
					/>
				</TableCell>
			</TableRow>
			{expanded && (
				<TableRow>
					<TableCell colSpan={columnCount + 1}>{expandedContent}</TableCell>
				</TableRow>
			)}
		</>
	);
}

export default ExpandableTableRow;
